import React from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { withNamespaces } from "react-i18next";
import moment from "moment-timezone";
import get from "lodash/get";
import forEach from "lodash/forEach";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  delegationLogPDFSnapshotsRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import FileLink from "../../components/FileLink/FileLink";

class DelegationPdfSnapshots extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      snapshots: [],
      loadingPdf: [],
      previewLoadingPdf: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    this.getDelegationLogSnapshots();
  }

  getDelegationLogSnapshots = async () => {
    this.setState({ isLoading: true });
    try {
      const { data } = await delegationLogPDFSnapshotsRequest(this.props.id);
      const dataSet = [];
      let currentMajorVersion = '';

      forEach(data, (item) => {
        if (currentMajorVersion !== item.major_version) {
          currentMajorVersion = item.major_version;
          dataSet.push({ major_version: item.major_version });
        }
        dataSet.push(item);
      });

      this.setState({ snapshots: dataSet });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }

    this.setState({ isLoading: false });
  };

  render() {
    const { snapshots, isLoading } = this.state;

    const columns = [
      {
        dataIndex: "delegation_log_version",
        key: "delegation_log_version",
        title: this.props.i18n.t("Version"),
        render: (val, row) => <span>{val ? val : <b>{row.major_version}</b>}</span>,
      },
      {
        dataIndex: "delegation_log_status",
        key: "delegation_log_status",
        title: this.props.i18n.t("Status"),
        render: (val) => val && <span>{val}</span>,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("Date"),
        render: (val) => (
          val && <span>
            {moment
              .utc(val)
              .tz(this.props.userTimezone || "UTC")
              .format("YYYY-MM-DD HH:mm")}{" "}
            {` ${this.props.userTimezone || "UTC"}`}
          </span>
        ),
      },
      {
        dataIndex: "file_url",
        key: "file_url",
        title: "",
        render: (val) => (
          val && <div style={{ margin: '6px 0 -6px' }}>
            <FileLink url={val} text='View' />
          </div>
        ),
      },
      {
        dataIndex: "signature_certificate_url",
        key: "signature_certificate_url",
        title: "",
        render: (val) => (
          val && <div style={{ margin: '6px 0 -6px' }}>
            <FileLink url={val} text={this.props.i18n.t("NamespaceDelegationLogs:Certificate")} icon='container' />
          </div>
        ),
      },
    ];

    return (
      <div>
        <h4 className="headline">{this.props.i18n.t("NamespaceDelegationLogs:PDF snapshots")}</h4>
        <br />
        <Table
          columns={columns}
          dataSource={snapshots}
          loading={isLoading}
          rowKey="id"
          pagination={false}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DelegationPdfSnapshots))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/DelegationPdfSnapshots.js